import { useEffect, useState } from 'react'

import { Input, Modal } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { Statuses } from '../../../utils/entities/aphmAnomaly'

const { TextArea } = Input

const AphmAnomalyHandleModal = ({ anomaly = null, status = null, loading = false, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)
  const [comment, setComment] = useState('')

  const visible = anomaly !== null && status !== null

  useEffect(() => { if (!visible) { setComment('') } }, [visible])

  const isIgnoring = status === Statuses.IGNORED

  return (
    <Modal
      visible={visible}
      title={t(isIgnoring ? 'aphm_anomaly.actions.ignore_title' : 'aphm_anomaly.actions.handle_title')}
      onCancel={onCancel}
      onOk={() => onConfirm(comment.trim())}
      okText={t(isIgnoring ? 'aphm_anomaly.actions.ignore' : 'aphm_anomaly.actions.handle')}
      cancelText={t('common.cancel')}
      confirmLoading={loading}
      destroyOnClose
      centered
    >
      <div className='modal-inner-container'>
        {t(isIgnoring ? 'aphm_anomaly.actions.ignore_content' : 'aphm_anomaly.actions.handle_content')}
      </div>
      <div className='mt-16'>
        <TextArea
          maxLength={500}
          rows={4}
          value={comment}
          placeholder={t('aphm_anomaly.actions.comment_placeholder')}
          onChange={event => setComment(event.target.value)}
        />
      </div>
    </Modal>
  )
}

export default AphmAnomalyHandleModal
